var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-auto"},[_c('v-tooltip',{attrs:{"bottom":"","open-delay":"300"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"ml-2 status-icon",attrs:{"size":"20"}},'v-icon',attrs,false),on),[_vm._v(" "+_vm._s(_vm.icon)+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }